import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { projectConstants } from '../../../shared/constants/project-constants';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountUserService } from 'src/app/services/account-user.service';
@Component({
  selector: 'app-booking-stat-list',
  templateUrl: './booking-stat-list.component.html',
  styleUrls: ['./booking-stat-list.component.css']
})
export class BookingStatListComponent implements OnInit {
  tableFilters = '';
  displayedColumns = ['uid', 'accountname', 'mobile', 'email', 'booking', 'details'];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) go: ElementRef;
  screenHeight;
  screenWidth;
  small_device_display = false;
  user: any;
  type: any;
  statType: string;
  DateCatogory: string;
  StatDateType: string;
  account: string;
  apptData;
  appt_details_sp: any;
  appt: any;
  accEncUid;
  businessName;
  subDomain;
  domain;
  email;
  accId: any;
  stat_type: any;
  stat_datetype: any;
  includeTest: any;
  start_date: any;
  applied_filter: any;
  end_date: any;
  date_category: any;
  showappt_data: true;
  showcheckin_data: true;
  showorder_data: true;
  showorder_for_data: true;
  showorder_due_data: true;
  showcheckin_for_data: true;
  showcheckin_due_data: true;
  showappt_due_data: true;
  showappt_for_data: true;
  showdonation_for_data: true;
  showpayment_for_data: true;
  tokenData;
  orderData;
  orderDatafor;
  orderDatadue;
  tokenDatafor;
  tokenDatadue;
  apptDataFor;
  apptDataDue;
  donationData;
  paymentData;
  mode_selection;
  value;
  isTeleservice: string;
  teleservice_data: boolean;
  constructor(
    private accountuserService: AccountUserService,
    private route: ActivatedRoute,
    private router: Router,
    private activatedRoute: ActivatedRoute,) {
  }
  ngOnInit() {
    this.stat_type = this.route.snapshot.params['statType'];
    this.stat_datetype = this.route.snapshot.params['StatDateType'];
    this.includeTest = this.route.snapshot.params['accountvalue'];
    this.date_category = this.route.snapshot.params['dayvalue'];
    this.start_date = this.route.snapshot.params['startvalue'];
    this.end_date = this.route.snapshot.params['endvalue'];
    this.applied_filter = this.route.snapshot.params['filter'];
    this.teleservice_data = this.route.snapshot.params['teleservice'];
    this.mode_selection = this.route.snapshot.params['mode'];
    this.isTeleservice = this.teleservice_data.toString();
    if (this.stat_type === 'CHECKIN' && this.stat_datetype === 'BOOKING_ON') {
      this.GoSPlistToken();
      this.showcheckin_data = true;
    }
    else if (this.stat_type === 'CHECKIN' && this.stat_datetype === 'BOOKING_SERVICE_DATE') {
      this.GoSPlistTokenFor();
      this.showcheckin_for_data = true;
    }
    else if (this.stat_type === 'CHECKIN_BOOKING_DUE' && this.stat_datetype === 'BOOKING_SERVICE_DATE') {
      this.GoSPlistTokenDue();
      this.showcheckin_due_data = true;
    }
    else if (this.stat_type === 'APPT_BOOKING_DUE' && this.stat_datetype === 'BOOKING_SERVICE_DATE') {
      this.GoSPlistApptDue();
      this.showappt_due_data = true;
    }
    else if (this.stat_type === 'APPT' && this.stat_datetype === 'BOOKING_SERVICE_DATE') {
      this.GoSPlistApptFor();
      this.showappt_for_data = true;
    }
    else if (this.stat_type === 'DONATION' && this.stat_datetype === 'BOOKING_ON') {
      this.GoSPlistDonation();
      this.showdonation_for_data = true;
    }
    else if (this.stat_type === 'PREPAYMENT' && this.stat_datetype === 'BOOKING_ON') {
      this.GoSPlistPayment();
      this.showpayment_for_data = true;
    }
    else if (this.stat_type === 'ORDER' && this.stat_datetype === 'BOOKING_ON') {
      this.GoSPlistOrder();
      this.showorder_data = true;
    }
    else if (this.stat_type === 'ORDER' && this.stat_datetype === 'BOOKING_SERVICE_DATE') {
      this.GoSPlistOrderFor();
      this.showorder_for_data = true;
    }
    else if (this.stat_type === 'ORDER_BOOKING_DUE' && this.stat_datetype === 'BOOKING_SERVICE_DATE') {
      this.GoSPlistOrderDue();
      this.showorder_due_data = true;
    }
    else {
      this.GoSPlistAppt();
      this.showappt_data = true;
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
  GoSPlistOrder() {
    this.statType = 'ORDER';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.orderData = data;
      }
    )
  }
  GoSPlistOrderFor() {
    this.statType = 'ORDER';
    this.StatDateType = 'BOOKING_SERVICE_DATE';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.orderDatafor = data;
      }
    )

  }
  GoSPlistOrderDue() {
    this.statType = 'ORDER_BOOKING_DUE';
    this.StatDateType = 'BOOKING_SERVICE_DATE';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.orderDatadue = data;
      }
    )
  }
  GoSPlistToken() {
    this.statType = 'CHECKIN';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.tokenData = data;
      }
    )
  }
  GoSPlistTokenFor() {
    this.statType = 'CHECKIN';
    this.StatDateType = 'BOOKING_SERVICE_DATE';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.tokenDatafor = data;
      }
    )

  }
  GoSPlistTokenDue() {
    this.statType = 'CHECKIN_BOOKING_DUE';
    this.StatDateType = 'BOOKING_SERVICE_DATE';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.tokenDatadue = data;
      }
    )
  }
  GoSPlistAppt() {
    this.statType = 'APPT';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.apptData = data;
      }
    )
  }
  GoSPlistApptFor() {
    this.statType = 'APPT';
    this.StatDateType = 'BOOKING_SERVICE_DATE';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.apptDataFor = data;
      }
    )
  }
  GoSPlistApptDue() {
    this.statType = 'APPT_BOOKING_DUE';
    this.StatDateType = 'BOOKING_SERVICE_DATE';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.apptDataDue = data;
      }
    )
  }
  GoSPlistDonation() {
    this.statType = 'DONATION';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
    } else {
      newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + this.applied_filter;
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.donationData = data;
      }
    )
  }
  GoSPlistPayment() {
    this.statType = 'PREPAYMENT';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
    } else {
      newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/dateType' + '/' + this.StatDateType + '/withTest' + '/' + this.includeTest + '/sp?' + this.applied_filter;
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.paymentData = data;
      }
    )
  }

  show_sp_details() {
    this.router.navigate(['../../accounts', 'details'], { queryParams: { accountId: 'stat' }, relativeTo: this.activatedRoute });
  }
  goBacktoList() {
    this.router.navigate(['../../accountStat'], { queryParams: { dateCatogory: this.date_category, isIncludeTest: this.includeTest, startDate: this.start_date, endDate: this.end_date, filterApplied: this.applied_filter, }, relativeTo: this.activatedRoute });
  }

}